<mat-toolbar class="titulopartes">Escolha a atividade que deseja copiar</mat-toolbar>
 <div style="width: 500px;">
    <div fxLayout="row" 
         fxLayoutGap="50px" 
         style="margin-top: 10px; margin-bottom: 10px" 
         fxFlexFill>
   
        <mat-form-field fxFlexOffset="20px" fxFlex="100%">
            <mat-label>Turma</mat-label>
            <mat-select [(ngModel)]="turmaSelecionada" name="turma"
                        (selectionChange)="carregarOficinas($event.value)">
                <mat-option *ngFor="let u of turmas" [value]="u">
                    {{u.descricao}}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="turmas?.length === 0" align="start">Nenhuma turma cadastrada</mat-hint>
        </mat-form-field>
    </div>
   
    <div fxLayout="row" 
         fxLayoutGap="50px" 
         style="margin-top: 20px; margin-bottom: 10px"
         fxFlexFill>
   
        <mat-form-field fxFlexOffset="20px" fxFlex="100%">
            <mat-label>Atividade</mat-label>
            <mat-select [(ngModel)]="oficinaSelecionada" name="oficina" 
                        [disabled]="!turmaSelecionada.id" >
                <mat-option *ngFor="let u of oficinas" [value]="u">
                    {{u.descricao}}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="oficinas?.length === 0" align="start">Nenhuma atividade cadastrada</mat-hint>
        </mat-form-field>
        
    </div> 
 </div>


 <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <div fxFlex="45%" fxLayoutAlign="center center">
        <button mat-button (click)="cancelar()"  
                color="primary"
                matTooltip="Cancelar a importação">
            Fechar
        </button>
    </div>

    <div fxFlex="45%" fxLayoutAlign="center center">
        <button mat-button (click)="copiarOficina()"  
                color="primary"
                matTooltip="Importar dados">
            Importar atividade
        </button>
    </div>
    
</div>